/* lua.js generated code 0.3.0 */
const Event = require("hecore/EventDispatcher").Event

require("clover/utils/MusicPlayer")
require("clover/utils/FrameLoader")

var Processor = xClass("LoadResourceProcessor", EventDispatcher)
Processor.prototype.start = function (scene) {

    var self = this
    var loader = FrameLoader.new()
    for (var i = 1, v = ResourceConfig.plist[1]; v; i++ , v = ResourceConfig.plist[i]) {
        loader.add(v)
    }
    for (var i = 1, v = ResourceConfig.mp3[1]; v; i++ , v = ResourceConfig.mp3[i]) {
        loader.add(v, kFrameLoaderType.mp3)
    }
    for (var i = 1, v = ResourceConfig.json[1]; v; i++ , v = ResourceConfig.json[i]) {
        loader.add(v, kFrameLoaderType.json)
    }
    for (var i = 1, v = ResourceConfig.homeExtCsb[1]; v; i++ , v = ResourceConfig.homeExtCsb[i]) {
        loader.add(v, kFrameLoaderType.csb)
    }
    for (var i = 1, v = ResourceConfig.homeExtFnt[1]; v; i++ , v = ResourceConfig.homeExtFnt[i]) {
        loader.add(v, kFrameLoaderType.fnt)
    }
    for (var i = 1, v = ResourceConfig.textList[1]; v; i++ , v = ResourceConfig.textList[i]) {
        loader.add(v, kFrameLoaderType.textList)
    }
    // for i, v in ipairs(ResourceConfig.sfx) do loader:add(v, kFrameLoaderType.sfx) end
    for (var i = 1, v = ResourceConfig.homejson[1]; v; i++ , v = ResourceConfig.homejson[i]) {
        loader.add(v, kFrameLoaderType.homejson)
    }
    for (var i = 1, v = ResourceConfig.asyncPlist[1]; v; i++ , v = ResourceConfig.asyncPlist[i]) {
        loader.add(v, kFrameLoaderType.plist)
    }
    if (__DEBUG || window.mini && mini.getPlatform() == MiniPlatform.tt){
        // 抖音需要额外加侧边栏的按钮资源
        for (var i = 1, v = ResourceConfig.tt[1]; v; i++ , v = ResourceConfig.tt[i]) {
            loader.add(v)
        }
    }

    var startTime = Localhost.clock()
    // var isNew = false

    // // FIXME: localUserConfig
    // // var localUserConfig = Localhost.getInstance().getLastLoginUserConfig()
    // // if (!localUserConfig || !localUserConfig.uid || localUserConfig.uid === 0 || !localUserConfig.sk || localUserConfig.sk === 0) {
    // //     isNew = true
    // // }
    // isNew = true
    // FIXME: event

    self.loaded = 0 // 已经加到进度上的
    function onFrameLoadComplete(evt) {
        loader.removeAllEventListeners()
        var endTime = Localhost.clock()
        cc.log("load resource done, total time:", endTime - startTime)
        // MusicPlayer.getInstance().playWorldSceneBgMusic()
        self.dispatchEvent(Event.new(Events.kComplete, null, self))
        // dc.dcGameLoading_5(tostring(UserManager.getInstance().appName), 120, isNew, (Localhost.clock() - startTime) * 1000)
    }
    function onFrameLoadProgress(evt) {
        var progress = (loader.loaded - self.loaded) / loader.getLength() * 0.6
        scene.addPercent(progress)
        self.loaded = loader.loaded
        // dc.dcGameLoading_5(tostring(UserManager.getInstance().appName), Math.floor(progress * 100), isNew, (Localhost.clock() - startTime) * 1000)
    }
    function onFrameLoadError() {
        require("clover/sns/SnsProxy").getInstance().alert('资源加载失败，请重试', () => loader.retry())
    }
    loader.addEventListener(Events.kComplete, onFrameLoadComplete)
    loader.addEventListener(Events.kProgress, onFrameLoadProgress)
    loader.addEventListener(Events.kError, onFrameLoadError)
    loader.load(true)
}
module.exports = Processor
